import AlertTriangle from '../../media/AlertTriangle.png';

export default function BaseFlexShapeValidationInfoRenderer(contractCode, minimumContiguousBlockSize, locale) {
  return (
    <div style={{ textAlign: 'left' }}>
      <img src={AlertTriangle} width={24} height={24} alt="" />
      <span>
        &nbsp;Elected energy values for <strong>{contractCode}</strong> must be in <strong>{minimumContiguousBlockSize}-hour continuous blocks</strong> or larger.
      </span>
    </div>
  );
}